import $ from 'jquery'
import { createAppVideoPlayer, destroyVideoPlayer } from 'video/videoJsPlayer'
import 'video/videoChapters'

export function initSection($section) {
  if ($section.find('.text-format').length) {
    SOPHIA.initMarkup($section);
  }

  if ($('audio', $section).length) {
    SOPHIA.initAudio($section.find('audio'))
  }
  else if ($section.hasClass('pdf_section')) {
    $section.pdfSectionsShow()
  }
  else if ($section.hasClass('video_section')) {
    createAppVideoPlayer($section)

    $('.video-chapters', $section).videoChapters();
  }
}

export function destroyVideoInSection($section) {
  if ($section.hasClass('video_section') || $section.hasClass('markup_section')) {
    $section.find('video').each((_, videoEl) => {
      destroyVideoPlayer(videoEl)
    })
  }
}
